/*
 * @Author:
 * @Date:
 * @Last Modified by: Brandon Leon
 * @Last Modified date: 2018-11-15
 */
import Activatepassword from './components/Activatepassword';

export default Activatepassword;
